import { NgTemplateOutlet } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})

export class ButtonComponent {
  @Input() color?: "gray2" | "primary" | "secondary" | "gray" | "dark" | "black" | "white" | "info" | "warning" | "error" | "success" = "primary";
  @Input() customColor?: undefined | string = undefined;
  @Input() customText?: undefined | string = undefined;
  @Input() size: "xs" | "sm" | "md" | "lg" | "xl" | "input" = "lg";
  @Input() variant: "solid" | "outline" = "solid";
  @Input() block: boolean = true;
  @Input() roundedRight: boolean = true;
  @Input() roundedLeft: boolean = true;
  @Input() roundedFull: boolean = false;

  @Input() type: "button" | "submit" | "reset" = "submit";
  @Input() href?: string | null = null;
  @Input() target?: string | null = null;
  @Output() onClick = new EventEmitter<Event>();

  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
}
